import $ from 'jquery';

$('form [required][placeholder]').each((i, elem) => {
    const $elem = $(elem);
    let placeholder = ($elem.attr('placeholder') || '').trim();
    if (placeholder !== '') {
        // remove first, in case there are already "*"
        placeholder = placeholder.replace(/\s*\*+$/, '');
        // add "*"
        placeholder += '*';
        $elem.attr('placeholder', placeholder);
    }
});
